import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import { ICardsProps } from "../../Cards"
import { CARD_NOSE_SHIFT_Y, ITimelineCard, NOSE_WIDTH } from "src/modules/pe-landing-module/data/interfaces"
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import { useEffect, useState } from "react"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { TimelineDot } from "./TimelineDot"


/* Protopia Ecosystem component */ 
const AMPLITUDE = 116,
    LENGTH = .27

const TimeLineDiagramDiagonal = ({...props}: ICardsProps): JSX.Element => {
    const sizes             = useScreenSize()
    const data = props.data 
    const is_two_side       = sizes.width >= WINDOW_WIDTH.TABLET && data.is_two_side 
    const cards: ITimelineCard[] = data.cards as ITimelineCard[]
    const perimeter         = data.dots.perimeter
    const getAmplitude = (): number => {
        return sizes.width >= WINDOW_WIDTH.TABLET
            ?
            !!data.dots && typeof data.dots?.amplitude !== "undefined" 
                ? 
                data.dots.amplitude 
                : 
                AMPLITUDE 
            :
            0
    }
    const shift                     = useSyncState<number>( getAmplitude() + 5 )
    const [length, setLength]       = useState<number>( data.dots?.length || LENGTH )
    const pathLength                = useSyncState<number>( 100 )
    const path                      = useSyncState<string>( "" )

    const getX = (y:number) : number => {
        const w = shift.get() * 2 
        const steps = pathLength.get() + perimeter
        const step = w / steps
        return step * y
    }
    const diagonal = ( ) => {        
        const steps = pathLength.get() + perimeter
        let _path = ""
        for(var i:number = 0; i < steps ; i++) {  
            const x = getX(i) + perimeter / 2
            _path += i === 0 
                ?
                `M${x} ${i}`
                :
                `L${x} ${i}`
            path.set(_path)
        }
    }
    
    useEffect(() => {
        shift.set(
            sizes.width >= WINDOW_WIDTH.TABLET ? getAmplitude() + 5 : 5
        )      
        const timeout = setTimeout(() => {
            const selector = `.landing-card-${cards[0]?.id}`
            pathLength.set(
                ( document.querySelector( selector )?.clientHeight || 0 ) * 
                ( is_two_side ? cards.length / 2 - ( ( cards.length / 2 ) % 2 ) / 2 : cards.length - 1 ) +
                perimeter/2
            )
            diagonal(  )
            // odds shift
            if( is_two_side ) {
                const selector = `.landing-v-timeline-cards-${props.section.id} .timeline-shifter`
                const query = document.querySelector(selector)!
                const card0 = document.querySelector(`.landing-card-${cards[0]?.id}`)
                query.setAttribute("style",`height:${ !!card0 ? card0.clientHeight / 2 : "0"}px`)
            }
        }, 100)
        return () => { 
            clearTimeout(timeout)
        }
    },[ data.dots, sizes.width, is_two_side ])

    const h = pathLength.get() + (data.gap || 0) * cards.length
    const w = shift.get() * 2 + perimeter
    return <div 
        className={`landing-v-timeline-timiline-container position-relative`} 
        style={{ 
            marginTop: CARD_NOSE_SHIFT_Y - perimeter + (data.gap || 0) / 2 + NOSE_WIDTH,
            width: w, maxWidth: w,
            marginLeft:  sizes.width >= WINDOW_WIDTH.TABLET 
                ? 
                is_two_side
                    ?
                    perimeter / 2 + NOSE_WIDTH + 30 
                    :
                    `calc(50% - ${(360 + w)/ 2}px)`
                : 
                -10,
            marginRight: sizes.width >= WINDOW_WIDTH.TABLET ? perimeter / 2 + NOSE_WIDTH + 30 : 10
        }} 
    >
        <svg 
            version="1.1" 
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            x="0px" 
            y="0px"
            width={ w }
            height={ h }
            viewBox={`0 0 ${ w } ${ h }`}
            xmlSpace="preserve"
            className=""
            style={{ 
                transform: `translateY(${ perimeter / 2}px)` 
            }}
        >
            <path 
                fill="none" 
                strokeWidth={data.dots?.stroke_width || 1 }
                stroke={ 
                    data.dots?.svg_style?.stroke 
                        ? 
                        data.dots?.svg_style.stroke 
                        : 
                        "var(--force-contast-color)" 
                }
                strokeMiterlimit="10"  
                style={data.dots?.svg_style} 
                d={path.get()}
            />
        </svg>
        {
            Array.isArray(cards) && cards.map((card: ITimelineCard, i: number) =>  { 
                return <TimelineDot
                    key={ card.id }
                    i={i}
                    section={ props.section } 
                    data={data}
                    card={card}
                    shift={shift.get()}
                    amplitude={0}
                    length={length}
                    phase={0}
                    is_two_side={is_two_side}
                    getX={getX}
                />
            })
        }
    </div>
}
export default TimeLineDiagramDiagonal